"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.NewAlerts = void 0;

var _react = _interopRequireWildcard(require("react"));

var _knotchincWebReactComponents = _interopRequireDefault(require("@bit/knotchinc.web-react-components.text"));

var _renderprops = require("react-spring/renderprops.cjs");

var _styled = require("./styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var NewAlerts = /*#__PURE__*/function (_Component) {
  _inherits(NewAlerts, _Component);

  var _super = _createSuper(NewAlerts);

  function NewAlerts(props) {
    var _this;

    _classCallCheck(this, NewAlerts);

    _this = _super.call(this, props);
    _this.state = {
      showBottomAlerts: true
    };
    _this.hideTimeout = null;
    return _this;
  }

  _createClass(NewAlerts, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      var alerts = this.props.alerts;

      if (alerts.length !== prevProps.alerts.length && alerts.length > 0) {
        this.setState({
          showBottomAlerts: true
        });
        clearTimeout(this.hideTimeout);
        this.hideTimeout = setTimeout(function () {
          _this2.setState({
            showBottomAlerts: false
          });
        }, 10000);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var showBottomAlerts = this.state.showBottomAlerts;
      var _this$props = this.props,
          alerts = _this$props.alerts,
          AlertComponent = _this$props.AlertComponent,
          closeAlert = _this$props.closeAlert,
          openNotifications = _this$props.openNotifications;
      var show = showBottomAlerts && alerts.length > 0;
      var showMoreAlertsBadge = alerts.length && alerts.length > 3;
      var firstAlerts = show ? alerts.slice(0, 3) : [];
      return /*#__PURE__*/_react["default"].createElement(_styled.NewAlertsContainer, {
        show: show
      }, /*#__PURE__*/_react["default"].createElement(_renderprops.Transition, {
        items: firstAlerts,
        keys: function keys(item) {
          return item.public_id;
        },
        from: {
          transform: 'translateX(50px)',
          opacity: 1,
          height: 0
        },
        enter: {
          height: 'auto',
          transform: 'translateX(0px)',
          opacity: 1
        },
        leave: [{
          opacity: 0
        }, {
          height: 0
        }],
        config: {
          mass: 2,
          tension: 200,
          friction: 54,
          precision: 0.085,
          velocity: 10
        }
      }, function (item) {
        return function (props) {
          return /*#__PURE__*/_react["default"].createElement(AlertComponent, {
            close: closeAlert,
            data: item,
            style: props
          });
        };
      }), showMoreAlertsBadge && /*#__PURE__*/_react["default"].createElement(_styled.MoreAlerts, {
        onClick: function onClick() {
          return openNotifications();
        }
      }, /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents["default"], {
        display: "inline-block",
        width: "50%",
        paddingLeft: "25px",
        textAlign: "left"
      }, "+", alerts.length - firstAlerts.length, " Alerts"), /*#__PURE__*/_react["default"].createElement(_styled.ShowMoreText, null, "Show me all alerts")));
    }
  }]);

  return NewAlerts;
}(_react.Component);

exports.NewAlerts = NewAlerts;
var _default = NewAlerts;
exports["default"] = _default;

//# sourceMappingURL=NewAlerts.js.map